import {connect} from 'react-redux'
import {push} from 'connected-react-router'
import {
    criminalHistoryDetailsSelect,
    populateCriminalHistoryListQuestionForReview,
    populateCriminalHistoryListDataForReview
} from '../../redux/selector/criminalDetailsSelector'
import { setCurrentAgentCriminalHistoryDetails } from '../../redux/slice/additionalApplicationsSlice'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton,
    LineSeperator,
    ErrorMark,
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import { useEffect, useState } from 'react'
import OffenceDetailsForm from '../../components/OffenceDetails/OffenceDetailsForm'
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    APPLICATION_TYPE_COLLECTOR,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    ROUTE_PATH,
} from '../../app/constants'
import { IsDateInFuture, replaceCollectorName, replaceUrlParams } from '../../app/utils';
import Navigation from '../Navigation'
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice'
import { ERROR_STRING } from '../../app/errors'
import { setAgencyCriminalHistoryDetails } from '../../redux/slice/primaryAgencyApplicationSlice'

const CriminalHistoryDetails = (props) => {
    
    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const collectorApplicantDetails = props.criminalHistoryDetails.collectorApplicantDetails
    const criminalHistoryDetails = props.criminalHistoryDetails[applicationType] ? 
        props.criminalHistoryDetails[applicationType] : props.criminalHistoryDetails

    const [showValidationError, setShowValidationError] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const defaultHistoryDetailObject = () => {
        return {
            people : null,
            dateOfOffence : 0,
            description : null
        }
    }

    let details = []

    if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY 
        || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) { 
        if(props.criminalHistoryDetails.criminalHistoryList &&
            Array.isArray(props.criminalHistoryDetails.criminalHistoryList)
            && props.criminalHistoryDetails.criminalHistoryList.length > 0 
        ) {
            details = props.criminalHistoryDetails.criminalHistoryList
        }
    } else if(applicationType === APPLICATION_TYPE_COLLECTOR 
        || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) { 
        if(props.criminalHistoryDetails.collectorCriminalHistoryDetails &&
            Array.isArray(props.criminalHistoryDetails.collectorCriminalHistoryDetails)
            && props.criminalHistoryDetails.collectorCriminalHistoryDetails.length > 0 
        ) {
            details = props.criminalHistoryDetails.collectorCriminalHistoryDetails
        }
    }

    if(details.length === 0) {
        details.push(defaultHistoryDetailObject())
    }

    const [historyDetails, setHistoryDetails] = useState(details)

    useEffect(() => {
        let details = []

        if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY 
            || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) { 
            if(props.criminalHistoryDetails.criminalHistoryList &&
                Array.isArray(props.criminalHistoryDetails.criminalHistoryList)
                && props.criminalHistoryDetails.criminalHistoryList.length > 0 
            ) {
                details = props.criminalHistoryDetails.criminalHistoryList
            }
        } else if(applicationType === APPLICATION_TYPE_COLLECTOR 
            || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) { 
            if(props.criminalHistoryDetails.collectorCriminalHistoryDetails &&
                Array.isArray(props.criminalHistoryDetails.collectorCriminalHistoryDetails)
                && props.criminalHistoryDetails.collectorCriminalHistoryDetails.length > 0 
            ) {
                details = props.criminalHistoryDetails.collectorCriminalHistoryDetails
            }
        }

        if(details.length === 0) {
            details.push(defaultHistoryDetailObject())
        }
        
        setHistoryDetails(details)
    }, [
        applicationType, 
        props.criminalHistoryDetails.criminalHistoryList, 
        props.criminalHistoryDetails.collectorCriminalHistoryDetails,
        setHistoryDetails
    ])
    // const [viewMode,setViewMode] = useState(props.viewMode ? 
    //     props.viewMode : (applicationModeInternal === APPLICATION_MODE_RENEW ? 
    //         VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    // this page is always in regular mode for now, even if its for "renew" process flow
    const [viewMode, setViewMode] = useState(props.viewMode ? props.viewMode : VIEW_MODE_REGULAR)

    const validateData = () => { 
        for(let i = 0; i < historyDetails.length ; i++) {
            let history = historyDetails[i]

            if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY
                || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) 
            {
                if(!history.people) {
                    return false
                } else if(!history.people.firstName) {
                    return false
                }
            }

            if(!history.dateOfOffence) {
                return false
            } else if(IsDateInFuture(history.dateOfOffence)) {
                return false
            }

            if(!history.description) {
                return false
            }
        }

        return true
    }

    const onNextClick =() => {

        setApplicationSaveError(false)

        if(!validateData()) {
            setShowValidationError(true)
            return
        }

        setShowValidationError(false)

        if(applicationType === APPLICATION_TYPE_COLLECTOR || 
            applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
            dispatch(setCurrentAgentCriminalHistoryDetails(historyDetails))
        } else { 
            dispatch(setAgencyCriminalHistoryDetails(historyDetails))
        }
        
        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
        .then((data) => {
            let nextUrl = criminalHistoryDetails.navigation.next

            if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT
                || applicationType === APPLICATION_TYPE_COLLECTOR) 
            {
                if (props.criminalHistoryDetails.collectorLicenceSuspensionData
                    && Array.isArray(props.criminalHistoryDetails.collectorLicenceSuspensionData)
                    && props.criminalHistoryDetails.collectorLicenceSuspensionData.length > 0) {
                    nextUrl = ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
                }
            } else if((viewMode === VIEW_MODE_RENEWAL_PREVIEW 
                || viewMode === VIEW_MODE_RENEWAL_EDIT
                || applicationMode === APPLICATION_MODE_RENEW)
                && criminalHistoryDetails.navigationRenewal) {
                nextUrl = criminalHistoryDetails.navigationRenewal.next
            }

            dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
        })
        .catch(err => {
            setApplicationSaveError(true)
        })
    }

    const onDetailsChange = (update) => {
        let index = parseInt(update.id)
        let updatedHistoryDetails = [...historyDetails]
        let updatedDetails = Object.assign({}, historyDetails[index], update.updatedDetails)
        updatedHistoryDetails.splice(index, 1,updatedDetails)
        setHistoryDetails(updatedHistoryDetails)
    }

    let historyComponents = []

    historyDetails.forEach((element, key) => {
        historyComponents.push(
            <div key={key} className="bottomMarginNormal">
                <div className="row">
                    <div className={"col-lg-8 bottomMarginNormal"}>
                        <OffenceDetailsForm 
                            id={key} 
                            onDetailsChange={onDetailsChange}
                            people={element.people}
                            dateOfOffence={element.dateOfOffence}
                            description={element.description} 
                            showValidationError={showValidationError}
                            peopleList={(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) ? props.criminalHistoryDetails.peopleList : null}
                        />
                    </div>
                    <div className={"col-lg-4"}>
                        <NavigationLinkButton
                                id={"branch-remove-link"}
                                text={"- Remove offence"}
                                onClick={() => {

                                    let historyDetailUpdate = [...historyDetails]
                                    historyDetailUpdate.splice(key, 1)
                                    setHistoryDetails(historyDetailUpdate)

                                    /*
                                    let details = [...branches]
                                    details.splice(index, 1)
                                    setBranches(details)
                                    */
                                }}
                        />
                    </div>
                </div>
                
                <LineSeperator />
            </div>
        )
    });

    let reviewData = []
    if(viewMode === VIEW_MODE_RENEWAL_PREVIEW)
        reviewData = populateCriminalHistoryListDataForReview(details)

    let collectorName = "Collector"

    if(collectorApplicantDetails && collectorApplicantDetails.firstName) {
        collectorName = collectorApplicantDetails.firstName
    }

    let paragraphText = (viewMode === VIEW_MODE_RENEWAL_PREVIEW) ? 
        criminalHistoryDetails.textRenewal : criminalHistoryDetails.text
    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
        paragraphText = paragraphText.map((text) => replaceCollectorName(text, collectorName))
    }

    return(
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode &&
                <>
                    <TopNavigationBar {...props} />
                    <div className="row">
                        <div className={"col-lg-8"}>
                            <Header 
                                id="criminal-history-details-header" 
                                header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? 
                                        criminalHistoryDetails.headerRenewal : criminalHistoryDetails.header} />
                            <Paragraph 
                                id="criminal-history-details-text"
                                text={paragraphText} />
                        </div>
                    </div>
                </>
                }
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                        <>
                            <ReviewForm data={populateCriminalHistoryListQuestionForReview(details)} />
                            {
                                reviewData.map((elsewhereData, index) => {
                                    return (
                                        <div key={"review-criminal-history-data-" + index}>
                                            <ReviewForm data={elsewhereData} />
                                            {(index < reviewData.length - 1)
                                                && <LineSeperator />} 
                                        </div>
                                    )
                                })
                            }
                        </>
                        }
                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                            historyComponents
                        }
                    </div>
                </div>

                {viewMode !== VIEW_MODE_RENEWAL_PREVIEW && 
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-8"}>
                            <NavigationLinkButton
                                id={"criminaly-history-add-more-link"}
                                text={"+ Add another offence"}
                                onClick={() => {
                                    let historyDetailUpdate = [...historyDetails, defaultHistoryDetailObject()]
                                    setHistoryDetails(historyDetailUpdate)
                                }}
                            />
                        </div>
                    </div>
                }

                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode &&
                    <div className="row bottomMarginNormal">
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button 
                                id="criminal-history-save-next"
                                text="Save and next"
                                buttonType="regular_primary"
                                onClick={onNextClick}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && <div className="help-block topMarginNormal">
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"criminal-history-details-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                            />
                        </div>}
                    </div>
                }
                {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT === viewMode &&
                    <div className="row bottomMarginNormal">
                        <div className={"col-lg-8"}>
                            <Button
                                id="criminal-history-edit-mode-save" 
                                text="Save"
                                buttonType="regular_primary"
                                onClick={() => {
                                    if(!validateData()) {
                                        setShowValidationError(true)
                                        return
                                    }
                            
                                    setShowValidationError(false)
                                    
                                    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
                                        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
                                        dispatch(setCurrentAgentCriminalHistoryDetails(historyDetails))
                                    } else { 
                                        dispatch(setAgencyCriminalHistoryDetails(historyDetails))
                                    }
                                    props.onEditSave()
                                }}
                            />
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default connect(criminalHistoryDetailsSelect)(CriminalHistoryDetails)
